export default __webpack_public_path__ + "static/media/batterySoc.71677024.svg";